import styled from 'styled-components'

import { Color, IColorScore } from '../hooks/use-game'
import TextInput from './text-input'
import ColorScore from './color-score'
import StoneScore from './stone-score'
import TotalScore from './total-score'

interface IProps {
  index: number
  colorScores: { [color in Color]: IColorScore }
  stoneScore: number
  totalScore: number
  setColorScore: (type: keyof IColorScore, color: Color, value: number) => void
  setStoneScore: (value: number) => void
}

export default function PlayerScore({
  index,
  colorScores,
  stoneScore,
  totalScore,
  setColorScore,
  setStoneScore,
}: IProps) {
  return (
    <Container>
      <div className="name-container">
        <TextInput placeholder={`Player ${index + 1}`} />
      </div>
      {Object.values(Color).map((color) => (
        <ColorScore
          color={color}
          setValue={(type: keyof IColorScore, value: number) => setColorScore(type, color, value)}
          value={colorScores[color]}
        />
      ))}
      <StoneScore setValue={setStoneScore} value={stoneScore} />
      <TotalScore value={totalScore} />
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  border-left: solid 1px #bc9b33;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  width: 22%;

  .name-container {
    align-items: center;
    border-bottom: solid 3px #bc9b33;
    display: flex;
    flex-direction: column;
    height: 7.5%;
    justify-content: center;
    padding: 0 4px;
    width: 100%;

    & > p {
      color: #000000;
      font-size: 18px;
    }
  }
`
